/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GameControllerDtoGameConfigUpdateRequest model module.
 * @module model/GameControllerDtoGameConfigUpdateRequest
 * @version 1.0
 */
class GameControllerDtoGameConfigUpdateRequest {
    /**
     * Constructs a new <code>GameControllerDtoGameConfigUpdateRequest</code>.
     * @alias module:model/GameControllerDtoGameConfigUpdateRequest
     */
    constructor() { 
        
        GameControllerDtoGameConfigUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameControllerDtoGameConfigUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameControllerDtoGameConfigUpdateRequest} obj Optional instance to populate.
     * @return {module:model/GameControllerDtoGameConfigUpdateRequest} The populated <code>GameControllerDtoGameConfigUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameControllerDtoGameConfigUpdateRequest();

            if (data.hasOwnProperty('configKey')) {
                obj['configKey'] = ApiClient.convertToType(data['configKey'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameControllerDtoGameConfigUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameControllerDtoGameConfigUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['configKey'] && !(typeof data['configKey'] === 'string' || data['configKey'] instanceof String)) {
            throw new Error("Expected the field `configKey` to be a primitive type in the JSON string but got " + data['configKey']);
        }
        // ensure the json data is a string
        if (data['value'] && !(typeof data['value'] === 'string' || data['value'] instanceof String)) {
            throw new Error("Expected the field `value` to be a primitive type in the JSON string but got " + data['value']);
        }

        return true;
    }


}



/**
 * @member {String} configKey
 */
GameControllerDtoGameConfigUpdateRequest.prototype['configKey'] = undefined;

/**
 * @member {String} value
 */
GameControllerDtoGameConfigUpdateRequest.prototype['value'] = undefined;






export default GameControllerDtoGameConfigUpdateRequest;

